import PropTypes from "prop-types";
import SuiBadge from "components/SuiBadge";
import SuiBox from "components/SuiBox";

const GroupsBadges = ({ groups }) => {
  return (
    <SuiBox display="flex" justifyContent="flex-end" gap={1}>
      {groups.map((group, index) => (
        <SuiBadge
          key={index}
          variant="gradient"
          badgeContent={group.name} // Since 'group' is now a string, we can directly use it as content
          color="secondary"
          size="extra-small"
        />
      ))}
    </SuiBox>
  );
};

GroupsBadges.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.string).isRequired, // Expecting an array of strings now
};

export default GroupsBadges;
